import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { X, Send, Loader2 } from 'lucide-react';
import { getRecaptchaToken } from '../utils/recaptcha';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const BookConsultationForm = ({ onClose }) => {
  const [formData, setFormData] = useState({
    name: '', email: '', phone: '', message: '', website: ''
  });
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.phone) return;

    setSubmitting(true);
    try {
      const recaptchaToken = await getRecaptchaToken('consultation');
      const res = await fetch(`${API_URL}/api/book-consultation`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...formData, recaptcha_token: recaptchaToken })
      });
      if (res.ok) {
        setSubmitted(true);
      }
    } catch (err) {
      void 0;
    }
    setSubmitting(false);
  };

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden" onClick={(e) => e.stopPropagation()}>
        <div className="bg-gradient-to-r from-purple-600 to-teal-600 px-6 py-5 flex items-center justify-between">
          <h3 className="text-xl font-bold text-white">Book a Consultation</h3>
          <button onClick={onClose} className="text-white/80 hover:text-white" data-testid="close-consultation-form">
            <X size={20} />
          </button>
        </div>

        {submitted ? (
          <div className="p-8 text-center">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Send size={28} className="text-green-600" />
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-2">Thank You!</h4>
            <p className="text-gray-600 mb-6">We've received your consultation request. Our team will be in touch shortly.</p>
            <Button onClick={onClose} className="bg-purple-600 hover:bg-purple-700 text-white rounded-full px-8">
              Close
            </Button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="p-6 space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Full Name *</label>
              <Input
                data-testid="consultation-name"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                placeholder="Your full name"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Email *</label>
              <Input
                data-testid="consultation-email"
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                placeholder="your@email.com"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Phone *</label>
              <Input
                data-testid="consultation-phone"
                value={formData.phone}
                onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                placeholder="+971..."
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Message (optional)</label>
              <Textarea
                data-testid="consultation-message"
                value={formData.message}
                onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                placeholder="Tell us briefly what you'd like help with..."
                rows={3}
              />
            </div>
            {/* Honeypot */}
            <div aria-hidden="true" style={{ position: 'absolute', left: '-9999px', height: 0, overflow: 'hidden' }}>
              <input type="text" value={formData.website} onChange={(e) => setFormData({ ...formData, website: e.target.value })} tabIndex={-1} autoComplete="off" />
            </div>
            <Button
              type="submit"
              disabled={submitting}
              data-testid="consultation-submit"
              className="w-full bg-gradient-to-r from-purple-600 to-teal-600 hover:from-purple-700 hover:to-teal-700 text-white rounded-full py-5"
            >
              {submitting ? <><Loader2 className="mr-2 animate-spin" size={18} /> Submitting...</> : 'Submit Request'}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
};

export default BookConsultationForm;
